import { Button } from '@undertheground/react';
import colors from '@undertheground/color';
import ButtonCover from "../../../../src/images/ButtonIcon/ButtonCover.png";
import LabelOnly from "../../../../src/images/ButtonIcon/LabelOnly.png";
import LabelWithIcon from "../../../../src/images/ButtonIcon/LabelWithIcon.png";
import IconOnly from "../../../../src/images/ButtonIcon/IconOnly.png";
import LabelOnlyPadding from "../../../../src/images/ButtonIcon/LabelOnlyPadding.png";
import LabelWithIconPadding from "../../../../src/images/ButtonIcon/LabelWithIconPadding.png";
import GhostPadding from "../../../../src/images/ButtonIcon/GhostPadding.png";
import IconOnlyPadding from "../../../../src/images/ButtonIcon/IconOnlyPadding.png";
import ScalingResponsive from "../../../../src/images/ButtonIcon/ScalingResponsive.png";
import ScalingWeb from "../../../../src/images/ButtonIcon/ScalingWeb.png";
import ScalingWithIconCorrect from "../../../../src/images/ButtonIcon/ScalingWithIconCorrect.png";
import ScalingWithIconWrong from "../../../../src/images/ButtonIcon/ScalingWithIconWrong.png";
import PrimaryBtnStates from "../../../../src/images/ButtonIcon/PrimaryBtnStates.png";
import SecondaryBtnStates from "../../../../src/images/ButtonIcon/SecondaryBtnStates.png";
import GhostBtnStates from "../../../../src/images/ButtonIcon/GhostBtnStates.png";
import * as React from 'react';
export default {
  Button,
  colors,
  ButtonCover,
  LabelOnly,
  LabelWithIcon,
  IconOnly,
  LabelOnlyPadding,
  LabelWithIconPadding,
  GhostPadding,
  IconOnlyPadding,
  ScalingResponsive,
  ScalingWeb,
  ScalingWithIconCorrect,
  ScalingWithIconWrong,
  PrimaryBtnStates,
  SecondaryBtnStates,
  GhostBtnStates,
  React
};